import { useQuery } from '@tanstack/react-query';
import { fetchFee } from '../services/smr-admin';
import { feeKeys } from './useFeesQuery';

export const useFeeQuery = (id?: string) =>
    useQuery({
        queryKey: feeKeys.detail(id ?? ''),
        queryFn: () => fetchFee(id as string),
        enabled: Boolean(id),
    });
